import React, { useEffect, useMemo, useState } from "react";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import { formContentContainer, loaderOverlay } from "../../Style/loaderOverly";
import { AvForm } from "availity-reactstrap-validation";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { createPageData, outwardFormData } from "./ScrabApprovalFile";
import { LoaderCreatePage } from "../Loader/Loader";
import {
  DownloadPDFData,
  formatNumber,
  getRecords,
  imageURL,
} from "../../services/api.service";
import UserDetailsModal from "../../components/CommonForBoth/TopbarDropdown/UserProfile/UserDetailModel";
import { toast } from "react-toastify";
import ScrabApprovalPDF from "./ScrabApprovalPDF/ScrabApprovalPDF";

const ScrabApprovalView = () => {
  const breadcrumbItems = [];
  const { id } = useParams();
  const navigate = useNavigate();

  const { payload, navigatePage, headerName, getEndpoint } = createPageData();
  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(outwardFormData());
  const [fetchedData, setFetchedData] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [isWarehouseModalOpen, setIsWarehouseModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPersonModalOpen, setIsPersonModalOpen] = useState(false);
  const [groupedItems, setGroupedItems] = useState({});
  const [isAssignModelOpem, setIsAssignModalOpen] = useState(false);
  const location = useLocation();

  let serialNumber = 1;

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  useEffect(() => {
    if (fetchedData) {
      let data = fetchedData;

      const updatedOutwardItems =
        data?.outward_items &&
        data?.outward_items?.map((item) => ({
          item_id: item?.item_id,
          buy_item_id: item?.buy_item_id,
          item_code: item?.item?.item_code,
          buy_item_code: item?.buyItem?.item_code,
          description: item?.buyItem?.description,
          uom: item.buyItem.uom?.uom_name,
          make_item_desc: item?.item?.description,
          make_item_uom: item.item?.uom?.uom_name,
          stock_qty: item?.stock_qty,
          is_make_item: item?.is_make_item,
          outward_qty: item?.outward_qty,
          is_active: item?.is_active,
          type: item.is_make_item ? 1 : 2,
          id: item.id,
          make_buy_name: item?.is_make_item
            ? item?.buyItem?.item_code + " (" + item?.makeItem?.item_code + ")"
            : item?.buyItem?.item_code,
        }));

      setFormData((prevState) => ({
        ...prevState,
        inputData: {
          ...prevState.inputData,
          ...data,
          outward_items: updatedOutwardItems,
        },
      }));
    }
  }, [fetchedData]);

  const getEditData = async (Id) => {
    try {
      let payload = {
        id: Id,
      };

      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.code == 1) {
        const data = responseData?.data;
        setFetchedData(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  const FloatValue = (value) => {
    return parseFloat(value);
  };

  // Filter items based on search query
  const filteredItems =
    formData?.inputData?.outward_items?.filter(
      (item) =>
        item?.item_code?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item?.buy_item_code?.toLowerCase().includes(searchQuery.toLowerCase())
    ) || [];

  useEffect(() => {
    if (!filteredItems || filteredItems.length === 0) return;

    const grouped = filteredItems.reduce((acc, item) => {
      if (!acc[item.item_code]) {
        acc[item.item_code] = {
          makeItem: { ...item, unique_id: `${item.item_code}-${item.id}` },
          buyItems: [],
        };
      }

      if (item.buy_item_code) {
        acc[item.item_code].buyItems.push({
          ...item,
          unique_id: `${item.buy_item_code}-${item.id}`,
        });
      }

      return acc;
    }, {});

    setGroupedItems(grouped);
  }, [filteredItems]);

  const handleApproveRejectScrab = async (scrabType) => {
    try {
      const projectId = JSON.parse(localStorage?.getItem("projectID"));
      const userData = JSON.parse(localStorage?.getItem("userDetails"));

      let payload = {
        outward_id: id,
        approval_status: scrabType == "approve" ? "Approved" : "Rejected",
        project_id: projectId,
        scrab_approved_by: userData.id,
      };

      const responseData = await getRecords(payload, "/approvedRejectScrab");
      if (responseData.code == 0) {
        toast.error(responseData.message || "Something Went Wrong");
        navigate("/scrap-approval-list");
        return;
      }
      if (scrabType == "approve") {
        toast.success("Scrap Approved Successfully");
        navigate("/scrap-approval-list");
      } else {
        toast.error("Scrap Rejected Successfully");
        navigate("/scrap-approval-list");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };
  const navigateBack = () => {
    if (location.state?.fromDashboard) {
      navigate("/dashboard");
    } else {
      navigate("/scrap-approval-list");
    }
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div style={formContentContainer}>
                    <AvForm className="needs-validation">
                      <div className="card mt-4">
                        <div className="card-header">
                          <h5>Scrap Approval Details</h5>
                          <Button
                            style={{ marginLeft: "10px" }}
                            color="secondary"
                            className="waves-effect waves-light me-1 back-button"
                            onClick={navigateBack}
                          >
                            Back
                          </Button>
                          <Button
                            color="success"
                            className="waves-effect waves-light me-1 back-button ml-2"
                            style={{ borderRadius: "50%" }}
                            onClick={() =>
                              DownloadPDFData("ScrabApprovalDetails.pdf")
                            }
                          >
                            <i class="fas fa-download"></i>
                          </Button>
                        </div>
                        <div className="card-body">
                          <Row>
                            {/* First Section (Left Side) */}
                            <Col
                              md="6"
                              className="border-end border-secondary p-3"
                            >
                              {isModalOpen && (
                                <UserDetailsModal
                                  onClose={() => setIsModalOpen(false)}
                                  id={formData?.inputData?.customer?.id}
                                  type="user"
                                />
                              )}
                              <p>
                                <strong>Project Name: </strong>
                                {formData?.inputData?.project?.project_name ? (
                                  <span
                                    className="text-primary hover-pointer"
                                    onClick={() =>
                                      navigate(
                                        `/project-view/${
                                          formData?.inputData?.project_id
                                            ? formData?.inputData?.project_id
                                            : formData?.inputData?.project?.id
                                        }`
                                      )
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    {formData?.inputData?.project?.project_name}
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </p>
                              <p>
                                <strong>Project Code: </strong>
                                {formData?.inputData?.project?.project_code ? (
                                  <span>
                                    {formData?.inputData?.project?.project_code}
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </p>
                              <p>
                                <strong>Warehouse: </strong>
                                <span
                                  className="text-primary cursor-pointer"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => setIsWarehouseModalOpen(true)}
                                >
                                  {formData?.inputData?.warehouse
                                    ?.warehouse_name || "-"}
                                </span>
                              </p>

                              {isWarehouseModalOpen && (
                                <UserDetailsModal
                                  onClose={() => setIsWarehouseModalOpen(false)}
                                  id={formData?.inputData?.warehouse?.id}
                                  type="warehouse"
                                />
                              )}
                              <p>
                                <strong>Outward No: </strong>
                                {(formData?.inputData?.outward_no &&
                                  formData?.inputData?.outward_no) ||
                                  "-"}
                              </p>
                              <p>
                                <strong>Assigned To: </strong>
                                <span
                                  className="text-primary hover-pointer"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => setIsPersonModalOpen(true)}
                                >
                                  {formData?.inputData?.contractor?.first_name +
                                    " " +
                                    formData?.inputData?.contractor
                                      ?.last_name || "-"}
                                </span>
                              </p>

                              {isPersonModalOpen && (
                                <UserDetailsModal
                                  onClose={() => setIsPersonModalOpen(false)}
                                  id={formData?.inputData?.contractor.id}
                                  type="user"
                                />
                              )}
                            </Col>

                            {/* Second Section (Right Side) */}
                            <Col md="6" className="p-3">
                              <p>
                                <strong>Assigned By: </strong>
                                <span
                                  className="text-primary hover-pointer"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => setIsAssignModalOpen(true)}
                                >
                                  {formData?.inputData?.createdBy?.first_name +
                                    " " +
                                    formData?.inputData?.createdBy?.last_name ||
                                    "-"}
                                </span>
                              </p>
                              {isAssignModelOpem && (
                                <UserDetailsModal
                                  onClose={() => setIsAssignModalOpen(false)}
                                  id={formData?.inputData?.createdBy.id}
                                  type="user"
                                />
                              )}

                              <p>
                                <strong>Vehicle No: </strong>
                                {formData?.inputData?.vehical_no || "-"}
                              </p>

                              <p>
                                <strong>Remark: </strong>
                                {formData?.inputData?.remark || "-"}
                              </p>

                              <p>
                                <strong>Status: </strong>
                                {formData?.inputData?.is_active
                                  ? "ACTIVE"
                                  : "IN-ACTIVE" || "-"}
                              </p>
                            </Col>
                          </Row>
                        </div>
                      </div>

                      <Row className="mt-4">
                        <div className="item-list-container">
                          <div className="d-flex justify-content-between align-items-center">
                            <h6 className="h-6-heading">Item Details</h6>
                            <div className="app-search d-flex d-lg-inline mt-0 p-0">
                              <div className="position-relative">
                                <input
                                  type="text"
                                  className="form-control ps-5"
                                  placeholder="Search by item code..."
                                  value={searchQuery}
                                  onChange={(e) =>
                                    setSearchQuery(e.target.value)
                                  }
                                  style={{
                                    width: "13rem",
                                    padding: "8px 15px",
                                    borderRadius: "8px",
                                    borderColor: "#D2D2D2",
                                    outline: "none",
                                    transition: "all 0.3s ease",
                                    boxShadow: "none",
                                    marginRight: "0.5rem",
                                  }}
                                />
                                <span className="ri-search-line"></span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="table mt-2"
                            style={{
                              overflowX: "auto",
                              overflowY: "auto",
                              maxHeight: "500px",
                              width: "100%",
                              scrollBehavior: "smooth",
                              scrollbarWidth: "thin",
                              msOverflowStyle: "none",
                              zIndex: 0,
                            }}
                          >
                            <table className="table table-hover">
                              <thead
                                style={{
                                  position: "sticky",
                                  top: 0,
                                  backgroundColor: "#8AC1E8",
                                  zIndex: 1,
                                }}
                              >
                                <tr style={{ borderBottom: "1px solid black" }}>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    Sr. No
                                  </th>
                                  <th
                                    style={{
                                      width: "18%",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Item Code
                                  </th>

                                  <th
                                    style={{
                                      width: "18%",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Item Description
                                  </th>
                                  <th
                                    style={{
                                      width: "15%",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    UOM
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                      width: "15%",
                                    }}
                                  >
                                    {formData?.inputData?.type == "Outward"
                                      ? "Stock QTY"
                                      : formData?.inputData?.type == "MRB"
                                      ? "Stock QTY"
                                      : formData?.inputData?.type == "Scrab"
                                      ? "MRB QTY"
                                      : "Stock QTY"}
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                      width: "15%",
                                    }}
                                  >
                                    {formData?.inputData?.type == "Outward"
                                      ? "Outward QTY"
                                      : formData?.inputData?.type == "MRB"
                                      ? "MRB QTY"
                                      : formData?.inputData?.type == "Scrab"
                                      ? "Scrap QTY"
                                      : "Stock QTY"}
                                  </th>
                                </tr>
                              </thead>

                              <tbody>
                                {Object.values(groupedItems)?.length === 0 ? (
                                  <tr>
                                    <td
                                      colSpan="10"
                                      style={{ textAlign: "center" }}
                                    >
                                      No data available.
                                    </td>
                                  </tr>
                                ) : (
                                  Object.values(groupedItems).map(
                                    (group, index) => (
                                      <React.Fragment
                                        key={group.makeItem.unique_id}
                                      >
                                        {group?.makeItem?.type == 1 && (
                                          <tr
                                            style={{
                                              fontWeight: "bold",
                                              backgroundColor: "#f0f8ff",
                                            }}
                                          >
                                            <td>{serialNumber++}</td>
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "180px",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  display: "-webkit-box",
                                                  WebkitBoxOrient: "vertical",
                                                  WebkitLineClamp: 2,
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "normal",
                                                }}
                                                title={
                                                  group?.makeItem?.item_code ||
                                                  "N/A"
                                                }
                                              >
                                                {group?.makeItem?.item_code ||
                                                  "N/A"}
                                              </div>
                                            </td>
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "180px",
                                              }}
                                            >
                                              {" "}
                                              <div
                                                style={{
                                                  display: "-webkit-box",
                                                  WebkitBoxOrient: "vertical",
                                                  WebkitLineClamp: 2,
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "normal",
                                                }}
                                                title={
                                                  group?.makeItem
                                                    ?.make_item_desc || "N/A"
                                                }
                                              >
                                                {group?.makeItem
                                                  ?.make_item_desc || "N/A"}
                                              </div>
                                            </td>
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "100px",
                                              }}
                                            >
                                              {" "}
                                              {group?.makeItem?.make_item_uom ||
                                                "N/A"}
                                            </td>
                                            <td>{"-"}</td>
                                            <td>{"-"}</td>
                                          </tr>
                                        )}

                                        {group?.buyItems
                                          ?.filter((item) => item.type == 1)
                                          ?.map((row, subIndex) => (
                                            <tr
                                              key={row.unique_id}
                                              style={{
                                                borderBottom: "1px solid #ccc",
                                              }}
                                            >
                                              <td>{`${serialNumber - 1}.${
                                                subIndex + 1
                                              }`}</td>
                                              {/* <td></td> */}
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "180px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "-webkit-box",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: 2,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "normal",
                                                  }}
                                                  title={
                                                    row?.buy_item_code || "N/A"
                                                  }
                                                >
                                                  {row?.buy_item_code || "N/A"}
                                                </div>
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "180px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "-webkit-box",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: 2,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "normal",
                                                  }}
                                                  title={
                                                    row?.description || "N/A"
                                                  }
                                                >
                                                  {row?.description || "N/A"}
                                                </div>
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                {row?.uom || "N/A"}
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                {formatNumber(row?.stock_qty) ||
                                                  0}
                                              </td>

                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "115px",
                                                }}
                                              >
                                                {formatNumber(row?.outward_qty)}
                                              </td>
                                            </tr>
                                          ))}
                                        {group?.buyItems
                                          ?.filter((item) => item.type == 2)
                                          ?.map((row, subIndex) => (
                                            <tr
                                              key={row.unique_id}
                                              style={{
                                                borderBottom: "1px solid #ccc",
                                              }}
                                            >
                                              <td>{serialNumber++}</td>

                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "180px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "-webkit-box",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: 2,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "normal",
                                                  }}
                                                  title={
                                                    row?.item_code || "N/A"
                                                  }
                                                >
                                                  {row?.item_code || "N/A"}
                                                </div>
                                              </td>

                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "180px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "-webkit-box",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: 2,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "normal",
                                                  }}
                                                  title={
                                                    row?.description || "N/A"
                                                  }
                                                >
                                                  {row?.description || "N/A"}
                                                </div>
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                {row?.uom || "N/A"}
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                {formatNumber(row?.stock_qty)}
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "115px",
                                                }}
                                              >
                                                {row?.outward_qty}
                                              </td>
                                            </tr>
                                          ))}
                                      </React.Fragment>
                                    )
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>

                          {formData?.inputData?.scrab_status == "Pending" && (
                            <div className="d-flex justify-content-center mt-3">
                              <Button
                                color="success"
                                className="waves-effect waves-light me-1 back-button ml-2"
                                onClick={() =>
                                  handleApproveRejectScrab("approve")
                                }
                              >
                                Approve
                              </Button>
                              <Button
                                color="danger"
                                className="waves-effect waves-light me-1 back-button ml-2"
                                onClick={() =>
                                  handleApproveRejectScrab("reject")
                                }
                              >
                                Reject
                              </Button>
                            </div>
                          )}
                        </div>
                        <div
                          style={{
                            display: "none",
                            position: "absolute",
                            left: "-9999px",
                          }}
                          id="pdfContent"
                        >
                          <ScrabApprovalPDF outwardData={formData?.inputData} />
                        </div>
                      </Row>
                    </AvForm>
                    {/* Loader Overlay */}
                    {loadingData && (
                      <div style={loaderOverlay}>
                        <LoaderCreatePage />
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ScrabApprovalView;
